let audioCtx: AudioContext | null = null

function getContext(): AudioContext {
  if (!audioCtx) {
    audioCtx = new AudioContext()
  }
  return audioCtx
}

/** Pleasant ascending two-tone chime */
export function playCorrect() {
  const ctx = getContext()
  const now = ctx.currentTime

  const gain = ctx.createGain()
  gain.connect(ctx.destination)
  gain.gain.setValueAtTime(0.15, now)
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.4)

  // First tone
  const osc1 = ctx.createOscillator()
  osc1.type = "sine"
  osc1.frequency.setValueAtTime(523.25, now) // C5
  osc1.connect(gain)
  osc1.start(now)
  osc1.stop(now + 0.15)

  // Second tone (higher)
  const gain2 = ctx.createGain()
  gain2.connect(ctx.destination)
  gain2.gain.setValueAtTime(0.15, now + 0.1)
  gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.5)

  const osc2 = ctx.createOscillator()
  osc2.type = "sine"
  osc2.frequency.setValueAtTime(659.25, now + 0.1) // E5
  osc2.connect(gain2)
  osc2.start(now + 0.1)
  osc2.stop(now + 0.35)
}

/** Soft low tone */
export function playIncorrect() {
  const ctx = getContext()
  const now = ctx.currentTime

  const gain = ctx.createGain()
  gain.connect(ctx.destination)
  gain.gain.setValueAtTime(0.12, now)
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.35)

  const osc = ctx.createOscillator()
  osc.type = "sine"
  osc.frequency.setValueAtTime(220, now) // A3
  osc.frequency.exponentialRampToValueAtTime(180, now + 0.25)
  osc.connect(gain)
  osc.start(now)
  osc.stop(now + 0.35)
}
